const defaultState = {
  orderFileList: [],
  loading: false,
  error: false,
  errorMessage: null
};

export const actionTypes = {
  orderFileListFetched: 'ORDER_FILE_LIST_FETCHED',
  catchError: 'CATCH_ERROR'
};

export const orderFilesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.orderFileListFetched: {
      const {orderFileList} = action.payload;
      return {
        ...state,
        loading: false,
        error: false,
        errorMessage: null,
        orderFileList: orderFileList
      };
    }

    case actionTypes.catchError: {
      const error = `FILE LIST: ${action.payload.error}`;
      return {...state, error};
    }

    default: return state;
  }
}

export const actions = {
  fileListFetched: (data) => ({
    type: actionTypes.orderFileListFetched,
    payload: data
  }),
  catchError: (error) => ({
    type: actionTypes.catchError,
    payload: {error}
  }),
};

